import styled from 'styled-components'

export const RichTextContainer = styled.div`
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 15px;
`
export const RichTextLabel = styled.p`
  position: absolute;
  margin: 0;
  top: -6px;
  left: 30px;
  font-weight: 600;
  font-size: 13px;
  z-index: 14;
`

export const RichTextSpan = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
`
